// Do not edit
export default "https://7hilw36156.execute-api.us-east-1.amazonaws.com/stage/";
